const Navbar = () => {
  return (
    <header class="navbar">
      <div class="container">
        <a href="#" class="logo">
          <img
            src="https://c3store.nyc3.digitaloceanspaces.com/mwpackaging/vectLogo.png"
            alt=""
          />
          <span>
            Midwest <br />
            Packaging <br />
            Partners
          </span>
        </a>
        <nav>
          <ul class="nav-links">
            <li>
              <a href="#1">Who We Are</a>
            </li>
            <li>
              <a href="#2">Products</a>
            </li>
            <li>
              <a href="#3">About</a>
            </li>
            <li>
              <a href="#4">Contact</a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
